import { MapContainer, TileLayer, Polyline, CircleMarker, Tooltip } from "react-leaflet";

export function RouteMiniMap({ geometry = [], closures = [], length = null, height = 220 }) {
  const pts = (geometry || []).filter((p) => Array.isArray(p) && p.length >= 2).map((p) => [p[0], p[1]]);
  const clPts = (closures || []).filter((c) => c && c.lat != null && c.lng != null);
  const bounds = pts.length ? pts : (clPts.length ? clPts.map((c) => [c.lat, c.lng]) : null);
  const center = pts.length ? pts[Math.floor(pts.length / 2)] : (clPts[0] ? [clPts[0].lat, clPts[0].lng] : [52.2297, 21.0122]);
  const start = pts[0];
  const end = pts[pts.length - 1];
  const lenTxt = length != null ? `${Math.round(length)} m` : null;
  return (
    <div className="relative rounded-xl overflow-hidden border border-slate-700" style={{ height }} data-testid="object-info-minimap">
      {lenTxt && (
        <div className="absolute top-2 right-2 z-[500] bg-slate-950/85 text-cyan-200 text-[11px] font-semibold rounded-lg px-2 py-1 border border-cyan-500/30" data-testid="minimap-length">
          Długość trasy: {lenTxt}
        </div>
      )}
      <MapContainer center={center} zoom={15} bounds={bounds && bounds.length ? bounds : undefined} boundsOptions={{ padding: [30, 30] }}
        zoomControl={false} scrollWheelZoom={false} className="w-full h-full" style={{ background: "#0b1120" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" maxZoom={19} />
        {pts.length >= 2 && <Polyline positions={pts} pathOptions={{ color: "#06b6d4", weight: 4, opacity: 0.95 }} />}
        {start && (
          <CircleMarker center={start} radius={7} pathOptions={{ color: "#22c55e", fillColor: "#22c55e", fillOpacity: 1 }} data-testid="minimap-start">
            <Tooltip permanent direction="left">Początek</Tooltip>
          </CircleMarker>
        )}
        {end && (
          <CircleMarker center={end} radius={7} pathOptions={{ color: "#ef4444", fillColor: "#ef4444", fillOpacity: 1 }} data-testid="minimap-end">
            <Tooltip permanent direction="right">Koniec</Tooltip>
          </CircleMarker>
        )}
        {clPts.map((c, i) => (
          <CircleMarker key={i} center={[c.lat, c.lng]} radius={6}
            pathOptions={{ color: "#f59e0b", fillColor: "#f59e0b", fillOpacity: 0.9 }} data-testid={`minimap-closure-${i}`}>
            <Tooltip>{c.number || "Mufa"}{c.role ? ` · ${c.role}` : ""}</Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
